import type React from "react";
import { createOpenStore } from "stores/createOpenStore";

/** A destructive act asked about from anywhere; bound to its target when asked. */
export interface ConfirmOpen {
  title: string;
  message: React.ReactNode;
  confirmText: string;
  onConfirm: () => void;
}

export const useConfirmStore = createOpenStore<ConfirmOpen>();

export const askConfirm = (ask: ConfirmOpen): void =>
  useConfirmStore.getState().show(ask);
